module.exports = __webpack_public_path__ + "img/infoSheetAct.075caf3f.png";